const createIcon = (name) => {
    return (iconFn) => {
        iconFn.displayName = name;
        return iconFn;
    };
};

export { createIcon };
//# sourceMappingURL=index.js.map
